export default __webpack_public_path__ + "static/media/logOut.c5494152.svg";